import { defineMessages } from 'react-intl';

/** The chart and the blocks of the overview, and the tables of the sections (design b1, c, d). */
export const streamingBlockMessages = defineMessages({
  chartTitle: { id: 'app.sml.streaming.chart.title', defaultMessage: '{metric} per day' },
  chartNumber: { id: 'app.sml.streaming.chart.number', defaultMessage: 'Number' },
  splitBy: { id: 'app.sml.streaming.chart.splitBy', defaultMessage: 'Split by' },
  splitTotal: { id: 'app.sml.streaming.chart.split.total', defaultMessage: 'Total' },
  splitSource: { id: 'app.sml.streaming.chart.split.source', defaultMessage: 'Source' },
  splitStore: { id: 'app.sml.streaming.chart.split.store', defaultMessage: 'Store' },
  splitCountry: { id: 'app.sml.streaming.chart.split.country', defaultMessage: 'Country' },
  splitNeedsSource: {
    id: 'app.sml.streaming.chart.splitNeedsSource',
    defaultMessage: 'Split by store or country when a connected source reports it',
  },
  chartEmpty: { id: 'app.sml.streaming.chart.empty', defaultMessage: 'No days with this number in the period yet.' },
  topTracks: { id: 'app.sml.streaming.block.topTracks', defaultMessage: 'Top tracks' },
  allTracks: { id: 'app.sml.streaming.block.allTracks', defaultMessage: 'All tracks' },
  stores: { id: 'app.sml.streaming.block.stores', defaultMessage: 'Stores' },
  allStores: { id: 'app.sml.streaming.block.allStores', defaultMessage: 'All {count} stores' },
  countries: { id: 'app.sml.streaming.block.countries', defaultMessage: 'Countries' },
  allCountries: { id: 'app.sml.streaming.block.allCountries', defaultMessage: 'All {count} countries' },
  playlists: { id: 'app.sml.streaming.block.playlists', defaultMessage: 'Playlists' },
  playlistsCount: {
    id: 'app.sml.streaming.block.playlistsCount',
    defaultMessage: '{count, plural, one {# playlist} other {# playlists}}',
  },
  allPlaylists: { id: 'app.sml.streaming.block.allPlaylists', defaultMessage: 'All playlists' },
  emptyList: { id: 'app.sml.streaming.block.empty', defaultMessage: 'Nothing in this period yet.' },
  colRank: { id: 'app.sml.streaming.col.rank', defaultMessage: '#' },
  colTrack: { id: 'app.sml.streaming.col.track', defaultMessage: 'Track' },
  colStore: { id: 'app.sml.streaming.col.store', defaultMessage: 'Store' },
  colCountry: { id: 'app.sml.streaming.col.country', defaultMessage: 'Country' },
  colShare: { id: 'app.sml.streaming.col.share', defaultMessage: 'Share' },
  colChange: { id: 'app.sml.streaming.col.change', defaultMessage: 'Change' },
  colPlaylist: { id: 'app.sml.streaming.col.playlist', defaultMessage: 'Playlist' },
  colCurator: { id: 'app.sml.streaming.col.curator', defaultMessage: 'Curator' },
  colSkipRate: { id: 'app.sml.streaming.col.skipRate', defaultMessage: 'Skip rate' },
  colFollowers: { id: 'app.sml.streaming.col.followers', defaultMessage: 'Followers' },
  colSource: { id: 'app.sml.streaming.col.source', defaultMessage: 'Source' },
  byCurator: { id: 'app.sml.streaming.playlist.byCurator', defaultMessage: 'by {curator}' },
  tracksCount: {
    id: 'app.sml.streaming.tracks.count',
    defaultMessage: '{count, plural, one {# track} other {# tracks}}',
  },
  tracksNoteDistributor: {
    id: 'app.sml.streaming.tracks.noteDistributor',
    defaultMessage: 'Streams, listeners and earnings: {source}, all stores.',
  },
  tracksNotePortals: {
    id: 'app.sml.streaming.tracks.notePortals',
    defaultMessage: 'Streams and listeners: {sources}.',
  },
  tracksNoteSaves: { id: 'app.sml.streaming.tracks.noteSaves', defaultMessage: 'Saves: Spotify for Artists.' },
  storesSumNote: {
    id: 'app.sml.streaming.stores.sumNote',
    defaultMessage: 'The rows come from different sources, so they can add up to more than the Streams total.',
  },
  storesCount: {
    id: 'app.sml.streaming.stores.count',
    defaultMessage: '{count, plural, one {# store} other {# stores}}',
  },
  countriesCount: {
    id: 'app.sml.streaming.countries.count',
    defaultMessage: '{count, plural, one {# country} other {# countries}}',
  },
  dimensionNote: {
    id: 'app.sml.streaming.dimension.note',
    defaultMessage: 'As reported by {source} for {start} – {end}. Change is against {prevStart} – {prevEnd}.',
  },
  dimensionNoteNoPrevious: {
    id: 'app.sml.streaming.dimension.noteNoPrevious',
    defaultMessage: 'As reported by {source} for {start} – {end}.',
  },
  rankOf: { id: 'app.sml.streaming.dimension.rankOf', defaultMessage: '{rank} of {count}' },
  rank: { id: 'app.sml.streaming.dimension.rank', defaultMessage: 'Rank' },
  closeDetail: { id: 'app.sml.streaming.dimension.close', defaultMessage: 'Close' },
  allStoresFilter: { id: 'app.sml.streaming.playlists.allStores', defaultMessage: 'All stores' },
  allCuratorsFilter: { id: 'app.sml.streaming.playlists.allCurators', defaultMessage: 'All curators' },
  playlistsNoteStreams: { id: 'app.sml.streaming.playlists.noteStreams', defaultMessage: 'Streams: Ditto.' },
  playlistsNoteFollowers: {
    id: 'app.sml.streaming.playlists.noteFollowers',
    defaultMessage: 'Followers: Spotify for Artists, Deezer for Creators.',
  },
  playlistsNoteSkip: {
    id: 'app.sml.streaming.playlists.noteSkip',
    defaultMessage: '— The source does not give this number.',
  },
  trackHead: { id: 'app.sml.streaming.track.head', defaultMessage: 'Released {date}' },
  trackCodes: { id: 'app.sml.streaming.track.codes', defaultMessage: 'ISRC {isrc} · UPC {upc}' },
  trackIsrc: { id: 'app.sml.streaming.track.isrc', defaultMessage: 'ISRC {isrc}' },
  byStore: { id: 'app.sml.streaming.track.byStore', defaultMessage: 'By store' },
  byCountry: { id: 'app.sml.streaming.track.byCountry', defaultMessage: 'By country' },
  whatEachReports: { id: 'app.sml.streaming.track.whatEachReports', defaultMessage: 'What each source reports' },
  trackDaily: { id: 'app.sml.streaming.track.daily', defaultMessage: 'Streams per day on {source}' },
  trackNotFound: {
    id: 'app.sml.streaming.track.notFound',
    defaultMessage: 'This track has no numbers in the period.',
  },
  backToTracks: { id: 'app.sml.streaming.track.back', defaultMessage: 'All tracks' },
});
